export type LeadDisplayNameInput = {
  name?: string | null;
  phone?: string | null;
  metadata?: Record<string, unknown> | null;
  channel?: string | null;
  externalUserId?: string | null;
  /** pushName da mensagem WhatsApp (metadata.pushName), quando disponível. */
  pushName?: string | null;
};

function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/** Nome cadastrado é só dígitos / igual ao telefone do lead. */
export function looksLikePhoneName(name: string, phone?: string | null): boolean {
  const trimmed = name.trim();
  if (!trimmed) return false;

  const nameDigits = digitsOnly(trimmed);
  if (nameDigits.length >= 8) {
    const compact = trimmed.replace(/[\s()+-]/g, "");
    if (/^\+?\d{8,15}$/.test(compact)) return true;
    if (phone) {
      const phoneDigits = digitsOnly(phone);
      if (
        phoneDigits &&
        (phoneDigits === nameDigits ||
          phoneDigits.endsWith(nameDigits) ||
          nameDigits.endsWith(phoneDigits))
      ) {
        return true;
      }
    }
  }
  return false;
}

function resolvePhoneDisplay(phone?: string | null, name?: string | null): string | null {
  const phoneTrimmed = phone?.trim();
  if (phoneTrimmed) return phoneTrimmed;
  const nameTrimmed = name?.trim();
  if (nameTrimmed && looksLikePhoneName(nameTrimmed, phone)) return nameTrimmed;
  return null;
}

/**
 * Nome amigável do lead para notificações e UI.
 * WhatsApp: se só houver telefone, exibe o número (não "User …").
 */
export function resolveLeadDisplayName(input: LeadDisplayNameInput): string {
  const meta = input.metadata ?? {};
  const channel = input.channel ?? "whatsapp";
  const externalUserId = input.externalUserId?.trim() ?? "";
  const instagramUsername =
    typeof meta.instagram_username === "string" ? meta.instagram_username.trim() : "";

  const pushName = input.pushName?.trim();
  if (pushName && !looksLikePhoneName(pushName, input.phone)) {
    return pushName;
  }

  const rawName = input.name?.trim();
  if (rawName && rawName !== instagramUsername && !looksLikePhoneName(rawName, input.phone)) {
    return rawName;
  }

  const instagramName =
    typeof meta.instagram_name === "string" ? meta.instagram_name.trim() : "";
  if (instagramName) return instagramName;

  if (instagramUsername) return `@${instagramUsername}`;

  // WhatsApp/Messenger: número é identidade válida quando não há nome real
  if (channel === "whatsapp" || channel === "messenger") {
    const phoneDisplay = resolvePhoneDisplay(input.phone, rawName);
    if (phoneDisplay) return phoneDisplay;
  }

  if (channel === "instagram" && externalUserId) {
    return `Instagram ${externalUserId.slice(-6)}`;
  }
  if (channel === "messenger" && externalUserId) {
    return `User ${externalUserId.slice(-6)}`;
  }
  return "Contato";
}
